import { metaTitle } from '../../util/tabTitle';
import { SchedulerTable } from './SchedulerTable';
import { ChangeEvent, FC, useState } from 'react';
import { Box, debounce, Stack } from '@mui/material';
import { DEBOUNCE_TIME } from '../../configs';
import Breadcrumbs from '../../components/Breadcrumb';
import { useIsUserRole } from '../../util/useIsUserRole';
import { UserRole } from '../../types/user.types';
import { AddSchedulerModal } from './components/AddSchedulerModal';
import { useHandleSearch } from '../../util/useHandleSearch';
import { useLocationSearch } from '../../util/useLocationSearch';
import {
  ManagementPageHeader,
  ManagementSearch,
  ManagementToolbar,
  RefreshAction,
} from '../../components/ManagementPageLayout';

const SchedulerPage: FC = () => {
  metaTitle('Scheduler');

  const searchVal = useLocationSearch();
  const [search, setSearch] = useState(searchVal || '');
  const [schedulerSearchTxt, setSchedulerSearchTxt] = useState(searchVal || '');
  const [refreshTable, setRefreshTable] = useState(false);
  const [open, setOpen] = useState(false);
  useHandleSearch(search);

  const setSearchText = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    setSchedulerSearchTxt(event.target.value);
  };

  const disableAddNew = useIsUserRole([
    UserRole.user,
    UserRole.layoutEditor,
    UserRole.dataEditor,
  ]);

  return (
    <Box sx={{ width: '100%', maxWidth: 1360, mx: 'auto' }}>
      <Breadcrumbs
        items={[
          {
            label: 'Schedulers',
            to: '/scheduler',
            description:
              'This page showcases all the presentation schedules. Each scheduler consists of multiple events, which represent specific time frames allocated for presentations. Schedulers are assigned to devices, and based on the events within the schedule, the device will display the corresponding presentations accordingly.',
          },
        ]}
      />
      <ManagementPageHeader
        title="Scheduler"
        subtitle="Plan and automate when presentations play on your displays."
        actionLabel="New schedule"
        onAction={() => setOpen(true)}
        actionDisabled={disableAddNew}
      />
      <ManagementToolbar>
        <ManagementSearch
          placeholder="Search schedules"
          value={search}
          onChange={(event) => {
            setSearch(event.target.value);
            debounce(() => setSearchText(event), DEBOUNCE_TIME)();
          }}
        />
        <Stack direction="row" justifyContent="flex-end">
          <RefreshAction onClick={() => setRefreshTable(!refreshTable)} />
        </Stack>
      </ManagementToolbar>

      <SchedulerTable
        refresh={refreshTable}
        schedulerSearchTxt={schedulerSearchTxt as string}
      />
      <AddSchedulerModal onClose={() => setOpen(false)} open={open} />
    </Box>
  );
};

export default SchedulerPage;
